<template>
  <BaseTemplate >
      <div class="bg_white pt16 pb16 boxs1">
        <GeneralTitle :title="'セミナールーム利用申請(予約)'" />
        <div class="mt16 pl16 pr16">
          <SidebarTitle :title="'利用するサロンを選択'" />

          <BaseSelect :value="RESERVATION_SELECTED_SALON_ID" @input="updateSelectedSalonId" class="mt10">
            <option v-for="(val, index) in RESERVATION_SALON_LIST" :value="val.salonId" :key="index">{{ val.salonName }}</option>
          </BaseSelect>
        </div>
      </div>

      <div class="bg_white mt16 pt16 pb16 boxs1">
        <div class="pl16 pr16">
          <SidebarTitle :title="'利用する部屋を選択'" />
          <BaseSelect :value="RESERVATION_SELECTED_ROOM_ID" @input="updateSelectedRoomId" class="mt10">
            <option v-for="(val, index) in RESERVATION_ROOM_LIST" :value="val.roomId" :key="index">{{ val.roomName }}</option>
          </BaseSelect>
          <div v-if="RESERVATION_SELECTED_ROOM_ID != ''" class="room mt16">
            <div class="room_image">
              <img :src="Config.APIURL + getRoomInfo('imageUrl')" alt="">
            </div>
            <div class="room_info">
              <div class="room_name ar">{{ getRoomInfo('roomName') }}</div>
              <div class="room_description ar">{{ getRoomInfo('description') }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg_white mt16 pt16 pb16 boxs1">
        <div class="pl16 pr16">
          <SidebarTitle :title="'開催日を選択'" />
          <BaseSelect :value="RESERVATION_SELECTED_BUSINESS_DAY" @input="updateSelectedBusinessDay" :fontStyle="'rb'" class="mt10">
            <option v-for="(val, index) in RESERVATION_BUSINESS_DAY_LIST" :value="val.businessDay" :key="index">{{ val.businessDayLabel }}</option>
          </BaseSelect>
        </div>
      </div>

      <div class="bg_white mt16 pt16 pb16 pl16 pr16 boxs1">
        <SidebarTitle :title="'利用可能時間'" />
        <div v-if="headerList.length > 0" class="table_info mt25">
          ◎：空室。予約可能です。<br>
          ×：予約受付済。ご予約いただけません。 <br>
          ※セミナールームは承認制の為、◎の表示でもご予約の受付ができない場合があります。
        </div>
        <table>
          <thead>
            <tr>
              <th v-for="(val, index) in headerList" :style="{width: 100 / headerList.length + '%'}" class="ab c5a" :key="val">
                <span v-if="index === 0" class="table_head"><img :src="require('@/assets/images/salon/salon_table_head.svg')" alt=""></span>
                <span v-else class="table_head">{{ val }}</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="val in dataList">
              <td v-for="(rowVal, index) in val" :class="{'not_empty' : rowVal == '×' || rowVal == '-'}" class="rb c5a" :key="rowVal + index">{{ rowVal }}</td>
            </tr>
          </tbody>
        </table>
        <div class="time_margin">
          <div class="time">
            <SidebarTitle class="mt16" :title="'利用開始時間'" />
            <div class="time_wrap">
              <div class="time_content">
                <BaseSelect :value="RESERVATION_SELECTED_START_LIST_HOUR" @input="updateSelectedStartListHour" :fontStyle="'rb'" class="time_select">
                  <option v-for="(val, index) in RESERVATION_START_LIST" :value="val.hour" class="select_text rb" :key="index">{{ val.hour }}</option>
                </BaseSelect>
                <div class="time_initial ab">時</div>
              </div>

              <div class="time_content">
                <BaseSelect :value="RESERVATION_SELECTED_START_LIST_MINUTE" @input="updateSelectedStartListMinute" :fontStyle="'rb'" class="time_select rb">
                  <option v-for="(val, index) in flattenedTimes(RESERVATION_START_LIST, RESERVATION_SELECTED_START_LIST_HOUR)" :value="val.minute" class="select_text rb" :key="index">{{ val.text }}</option>
                </BaseSelect>
                <div class="time_initial ab">分</div>
              </div>
            </div>
          </div>

          <div class="time">
            <SidebarTitle :title="'利用終了時間'" />
            <div class="time_wrap">
              <div class="time_content">
                <BaseSelect :value="RESERVATION_SELECTED_END_LIST_HOUR" @input="updateSelectedEndListHour" :fontStyle="'rb'" class="time_select">
                  <!-- <option v-for="(val, index) in RESERVATION_END_LIST" :value="val.hour" class="select_text rb" :key="index">{{ val.hour }}</option> -->
                  <option v-for="(val, index) in filteredEndList" :value="val.hour" class="select_text rb" :key="index">{{ val.hour }}</option>

                </BaseSelect>
                <div class="time_initial ab">時</div>
              </div>
              <div class="time_content">
                <BaseSelect :value="RESERVATION_SELECTED_END_LIST_MINUTE" @input="updateSelectedEndListMinute" :fontStyle="'rb'" class="time_select">
                  <!-- <option v-for="(val, index) in flattenedTimes(RESERVATION_END_LIST, RESERVATION_SELECTED_END_LIST_HOUR)" :value="val.minute" class="select_text rb" :key="index">{{ val.text }}</option> -->
                  <option v-for="(val, index) in flattenedEndTimes(filteredEndList, RESERVATION_SELECTED_END_LIST_HOUR, RESERVATION_SELECTED_START_LIST_HOUR, RESERVATION_SELECTED_START_LIST_MINUTE)" :value="val.minute" class="select_text rb" :key="index">{{ val.text }}</option>

                </BaseSelect>
                <div class="time_initial ab">分</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bg_white mt16 pb16 boxs1">
        <div class="pl16 pr16">
          <div class="btn_wrap">
            <BaseBtn
              :btnText="'確認'"
              :type="'blue'"
              @onClick="onClickReservationConfirm"
              class="reservation_btn"
            />
          </div>
        </div>
      </div>
      <BaseModal v-if="isModarOpen">
        <div v-for="(value, index) in errorList" class="ab error_text" :key="index">{{ value }}</div>
        <div class="mt16">
          <BaseBtn :btnText="'閉じる'" :type="'delete'" @onClick="onClickCloseModal" />
        </div>
      </BaseModal>

  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import Config from '@/config/config';
import SalonApi from '@/components/api/salon/reservation';
import BaseTemplate from '@/views/common/BaseTemplate.vue';
import SidebarTitle from '@/components/common/SidebarTitle.vue';
import GeneralTitle from '@/components/common/GeneralTitle.vue';
import BaseSelect from '@/components/common/BaseSelect.vue';
import BaseBtn from '@/components/common/BaseBtn.vue';
import BaseModal from '@/components/common/BaseModal.vue';


export default {
  components: {
      BaseTemplate,
      SidebarTitle,
      GeneralTitle,
      BaseSelect,
      BaseBtn,
      BaseModal
  },
  data() {
      return {
          Config: Config,
          headerList: [],
          dataList: [],
          isModarOpen: false,
          errorList: [],
          filteredEndList: [],
      }
  },
  methods: {
      getRoomInfo(name) {
        if(this.selecterRoomId == '')  return;

        const roomInfo = this.RESERVATION_ROOM_LIST.find((val) => {
          return val.roomId == this.RESERVATION_SELECTED_ROOM_ID;
        });

        if (!roomInfo || !(name in roomInfo)) {
          console.log(`Property "${name}" not found in the selected room.`);
          return;
        }
        return roomInfo[name]
      },
      flattenedTimes(hourlist, selectedValue) {
        if(selectedValue == '') return [];
        const minuteList = hourlist.find((val) => {
          return val.hour == selectedValue;
        });
        if(!minuteList) return [];
        return minuteList.minuteList;
      },
      updateEndList(startHour) {
        startHour = parseInt(startHour);
        this.filteredEndList = this.RESERVATION_END_LIST.filter(item => {
          if(this.RESERVATION_SELECTED_START_LIST_MINUTE == 45) {
            return item.hour > startHour;
          } else {
            return item.hour >= startHour;
          }
        });
      },

      flattenedEndTimes(hourlist, selectedValue, selectedStartHour, selectedStartMinute) {
          if(selectedValue == '') return [];
          let minuteList = hourlist.find((val) => {
              return val.hour == selectedValue;
          });

          if(!minuteList) return [];
          if(selectedStartHour < selectedValue) return minuteList.minuteList;

          // 利用開始時間と同じ時間の場合はそれ以降の分のみを表示します
          return minuteList = minuteList.minuteList.filter(item => {
              return item.minute > selectedStartMinute;
          });
      },
      resetEndSelectionIfInvalid() {
        const endHourIsValid = this.filteredEndList.some(item => item.hour == this.RESERVATION_SELECTED_END_LIST_HOUR);
        if (!endHourIsValid) {
            this.updateSelectedEndListHour('');
            this.updateSelectedEndListMinute('');
        } else {
            const endMinutesForHour = this.flattenedTimes(this.filteredEndList, this.RESERVATION_SELECTED_END_LIST_HOUR);
            const endMinuteIsValid = endMinutesForHour.some(item => item.minute == this.RESERVATION_SELECTED_END_LIST_MINUTE);
            if (!endMinuteIsValid) {
              this.updateSelectedEndListMinute('');
            }
        }
      },

      onClickCloseModal() {
        this.isModarOpen = false;
        this.errorList = [];
      },
      async onClickReservationConfirm() {
        console.log('clicl');
        if(this.RESERVATION_SELECTED_SALON_ID == '') {
          this.errorList.push('サロンを選択してください');
        }
        if(this.RESERVATION_SELECTED_ROOM_ID == '') {
          this.errorList.push('利用ルームを選択してください');
        }
        if(this.RESERVATION_SELECTED_BUSINESS_DAY == '') {
          this.errorList.push('開催日を選択してください');
        }
        if(this.RESERVATION_SELECTED_START_LIST_HOUR == '' || this.RESERVATION_SELECTED_START_LIST_MINUTE == '' ) {
          this.errorList.push('利用開始時間を選択してください');
        }
        if(this.RESERVATION_SELECTED_END_LIST_HOUR == '' || this.RESERVATION_SELECTED_END_LIST_MINUTE == '') {
          this.errorList.push('利用終了時間を選択してください');
        }
        // 終了時間が開始時間よりも前であるかをチェック
        const startTotalMinutes = parseInt(this.RESERVATION_SELECTED_START_LIST_HOUR) * 60 + parseInt(this.RESERVATION_SELECTED_START_LIST_MINUTE);
        const endTotalMinutes = parseInt(this.RESERVATION_SELECTED_END_LIST_HOUR) * 60 + parseInt(this.RESERVATION_SELECTED_END_LIST_MINUTE);

        if (startTotalMinutes >= endTotalMinutes) {
            this.errorList.push('終了時間は開始時間よりも後に設定してください');
        }


        const selecedRoom = this.RESERVATION_ROOM_LIST.find((val) => {
          return val.roomId == this.RESERVATION_SELECTED_ROOM_ID;
        });
        console.log(selecedRoom);
        if(!selecedRoom) {
          this.errorList.push('利用する部屋の情報がありません');
        }

        if(this.errorList.length > 0) {
          this.isModarOpen = true;
          return;
        }
        let requestData = this.API_RESERVATION_SALON_REQUEST_DATA;

        await this.apiCheckReservationTime(requestData).then((val) => {
          console.log('予約時間チェック');
          console.log(val);

          if(val.status == 400) {
            this.errorList.push(val.message);
            this.isModarOpen = true;
            return;
          }

          if(selecedRoom.inputSeminarInfo) {
            // セミナー(講師などの情報登録)
            this.$router.push({ name: 'ReservationSeminar' });
          } else {
            this.$router.push({ name: 'ReservationConfirm', query: { backUrl: 'Reservation' } });
          }
        });
      },

      async apiGetSalonList() {
          await SalonApi.getSalonList().then((val) => {
              console.log('サロンリスト');
              console.log(val);
              this.$store.commit('salon/RESERVATION_SET_SALON_LIST', val);
          });
      },
      async apiGetRoomList(salonId) {
        if(salonId == '') return;
          await SalonApi.getRoomList(salonId).then((val) => {
              console.log('ルームリスト');
              console.log(val);
              this.$store.commit('salon/RESERVATION_SET_ROOM_LIST', val);
          });
      },
      async apiGetBusinessDayList(roomId) {
        if(roomId == '') return;
        await SalonApi.getBusinessDayList(roomId).then((val) => {
            console.log('営業日リスト');
            console.log(val);
            this.$store.commit('salon/RESERVATION_SET_BUSINESS_DAY_LIST', val);
        });
      },
      async apiGetAvailabilityStatusTable(salonId, reservationDate) {
          if(reservationDate == '' || salonId == '') return;
          console.log(reservationDate);
          console.log(salonId);
          await SalonApi.getAvailabilityStatusTable(reservationDate, salonId).then((val) => {
              console.log(val);
              this.headerList = val.headerList;
              this.dataList = val.dataList;
          });
      },
      async apiGetReservationHours(roomId) {
        if(roomId == '') return;
          await SalonApi.getReservationHours(roomId).then((val) => {
              console.log('apiGetReservationHours');
              console.log(val);
              this.$store.commit('salon/RESERVATION_SET_START_LIST', val.startList);
              this.$store.commit('salon/RESERVATION_SET_END_LIST', val.endList);
          });
      },
      async apiCheckReservationTime(requestData) {
        return await SalonApi.checkReservationTime(requestData).then((val) => {
            return val;
        });
      },

      updateSelectedSalonId(newSalonId) {
        this.$store.commit('salon/RESERVATION_SET_SELECTED_SALON_ID', newSalonId);
      },
      updateSelectedRoomId(newRoomId) {
        this.$store.commit('salon/RESERVATION_SET_SELECTED_ROOM_ID', newRoomId);
      },
      updateSelectedBusinessDay(newBusinessDay) {
        this.$store.commit('salon/RESERVATION_SET_SELECTED_BUSINESS_DAY', newBusinessDay);
      },
      updateSelectedStartListHour(newStartListHour) {
        this.$store.commit('salon/RESERVATION_SET_SELECTED_START_LIST_HOUR', newStartListHour);
      },
      updateSelectedStartListMinute(newStartListMinute) {
        this.$store.commit('salon/RESERVATION_SET_SELECTED_START_LIST_MINUTE', newStartListMinute);
      },
      updateSelectedEndListHour(newEndListHour) {
        this.$store.commit('salon/RESERVATION_SET_SELECTED_END_LIST_HOUR', newEndListHour);
      },
      updateSelectedEndListMinute(newEndListMinute) {
        this.$store.commit('salon/RESERVATION_SET_SELECTED_END_LIST_MINUTE', newEndListMinute);
      },

      initialized() {
        this.apiGetSalonList();
        this.apiGetRoomList(this.RESERVATION_SELECTED_SALON_ID);
        this.apiGetBusinessDayList(this.RESERVATION_SELECTED_ROOM_ID);
        this.apiGetAvailabilityStatusTable(this.RESERVATION_SELECTED_SALON_ID, this.RESERVATION_SELECTED_BUSINESS_DAY);
        this.apiGetReservationHours(this.RESERVATION_SELECTED_ROOM_ID);
      }
  },
  async created() {
      this.initialized();
      await this.apiGetSalonList();
      this.updateEndList(this.RESERVATION_SELECTED_START_LIST_HOUR);
  },
  computed: mapGetters(
    'salon', [
      'RESERVATION_SALON_LIST',
      'RESERVATION_SELECTED_SALON_ID',
      'RESERVATION_BUSINESS_DAY_LIST',
      'RESERVATION_SELECTED_BUSINESS_DAY',
      'RESERVATION_ROOM_LIST',
      'RESERVATION_SELECTED_ROOM_ID',
      'RESERVATION_START_LIST',
      'RESERVATION_SELECTED_START_LIST_HOUR',
      'RESERVATION_SELECTED_START_LIST_MINUTE',
      'RESERVATION_END_LIST',
      'RESERVATION_SELECTED_END_LIST_HOUR',
      'RESERVATION_SELECTED_END_LIST_MINUTE',
      'API_RESERVATION_SALON_REQUEST_DATA',
    ],
  ),
  watch: {
    RESERVATION_SELECTED_SALON_ID() {
        console.log('selectedSalonId', this.RESERVATION_SELECTED_SALON_ID);
        this.$store.commit('salon/RESERVATION_SET_SELECTED_ROOM_ID', '');
        this.apiGetRoomList(this.RESERVATION_SELECTED_SALON_ID);
    },

    RESERVATION_SELECTED_ROOM_ID() {
        console.log('selectedRoomId', this.RESERVATION_SELECTED_ROOM_ID);
        this.apiGetBusinessDayList(this.RESERVATION_SELECTED_ROOM_ID);
        this.apiGetReservationHours(this.RESERVATION_SELECTED_ROOM_ID);
    },

    RESERVATION_SELECTED_BUSINESS_DAY() {
      console.log('selectedBusinessDay', this.RESERVATION_SELECTED_BUSINESS_DAY);
      this.apiGetAvailabilityStatusTable(this.RESERVATION_SELECTED_SALON_ID, this.RESERVATION_SELECTED_BUSINESS_DAY);
    },
    RESERVATION_SELECTED_START_LIST_HOUR: function(newVal) {
        this.updateEndList(newVal);
        this.resetEndSelectionIfInvalid();

    },
    RESERVATION_SELECTED_START_LIST_MINUTE(newVal) {
        this.updateEndList(this.RESERVATION_SELECTED_START_LIST_HOUR);
        this.resetEndSelectionIfInvalid();
    },

  }
}
</script>

<style lang="css" scoped>
table {
  text-align: center;
  width: 100%;
}
thead th {
  font-size: 14px;
  height: 65px;
  padding: 0;
  text-align: center;
}
.table_head {
  display: block;
  padding: 10px;
  width: 100%;
}
thead:after {
  display: block;
  content: '';
  height: 6px;
  background: #fff; /* 背景色はテーブルと同じにします */
  border-bottom: 1px solid #fff; /* ボーダーもテーブルと同じ色にします */
}

tbody tr:nth-child(2n) {
  border-bottom: 2px solid #A2A2A2;
}

th,td {
  border: 1px solid #A2A2A2;
  line-height: 1;
  padding: 15px 0;
}
td.not_empty {
  background-color: #ECECEC;
}

.room {
  display: flex;
  justify-content: space-between;
}
.room .room_image {
  width: 40%;
}
.room .room_info {
  width: 55%;
}

.room .room_name {
  border-bottom: 1px solid #C9C9C9;
  font-size: 12px;
  padding-bottom: 6px;
}
.room .room_description {
  font-size: 12px;
  margin-top: 8px;
}

.time_margin {
  margin-top: 64px;
}

.time {
  margin-top: 39px;
}
.time_wrap {
  display: flex;
  margin-top: 15px;
}

.time_content {
  align-items: center;
  display: flex;
  /* width: 50%; */
}
.time_content:last-child {
  margin-left: 38px;
}
.time_select {
  min-width: 66px;
}

.time_initial {
  margin-left: 20px;
}
.select_text {
  font-size: 18px;
}

.btn_wrap {
  /* display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px; */
  padding: 36px 0;
}
.reservation_btn {
  width: 100%;
}

.table_info {
  font-size: 12px;
  margin-top: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/salon/Reservation.vue